import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const UrineProteinLevelIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        d="M17.54 14.73L12 8V2H13C13.55 2 14 1.55 14 1C14 0.45 13.55 0 13 0H5C4.45 0 4 0.45 4 1C4 1.55 4.45 2 5 2H6V8L0.46 14.73C0.14 15.12 0 15.56 0 16C0.01 17.03 0.82 18 2 18H16C17.19 18 18 17.03 18 16C18 15.56 17.86 15.12 17.54 14.73Z"
        fill={color}
      />
    </IconBase>
  );
};

export default UrineProteinLevelIcon;
